module.exports = __webpack_public_path__ + "static/media/logoShwePuzzle-thadingyut-2025-theme.40fa40ed.png";